import { useContext, useEffect, useState } from 'react'
import CheckBox from '../../../../components/common/CheckBox'
import Button from '../../../../components/common/Button'
import { getRequest, postRequest } from '../../../../services/base'
import { useNavigate, useParams } from 'react-router-dom'
import { NavContext } from '../../../../context/global_context'
import TextArea from '../../../common/TextArea'
import InputText from '../../../common/InputText'
import SelectInput from '../../../common/SelectInput'

const CreateDtcForm = () => {
  const navigate = useNavigate()
  const [value, dispatch] = useContext(NavContext)

  let { vehicle } = useParams()
  const [payload, setPayload] = useState({
    create_dtc_circuits: false,
    clone_with_existing_mapping: false,
    target_dtcs: [],
    active: false,
    destination_only: false,
    short_description: '',
    description: '',
    description_2: '',
    ecu: '',
    name: '',
    make: vehicle,
  })
  const [ecusData, setEcusData] = useState([])

  useEffect(() => {
    getEcuData('')

    dispatch({
      type: 'header',
      data: {
        header: 'Admin Tools',
        sub_header: `Vehicle List / ${vehicle} / DTCs / Tracer Authoring Mappings / Create New DTC`,
        id: vehicle,
        show_back_btn: true,
        dtc_details: [],
        back_btn_url: `/vehicles/${vehicle}/dtcs/listing`,
      },
    })
  }, [])

  const saveDtcs = async (e) => {
    dispatch({
      type: 'loader',
      data: {
        caption: 'Saving DTC is in process',
        showLoader: true,
      },
      notification: {},
    })
    let res = await postRequest(`/api/dtcs/save/new/`, payload)
    if (res?.status) {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: `DTC's ${res.data.name} Saved Successfully, We will Redirect you to edit page.`,
        },
      })
      setTimeout(() => {
        navigate(`/vehicles/${vehicle}/dtcs/${res.data.id}/edit`)
      }, 500)
    } else {
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: res?.msg,
        },
      })
    }
  }

  const getEcuData = async (search) => {
    let response = await getRequest(
      `/api/ecu/ecu/?vehicle=${vehicle}&search=${search}`
    )
    if (response?.data?.length > 0) {
      setEcusData(response.data)
    }
  }

  const onEcuInputSearch = (option, searchText) => {
    if (option.data.label.toLowerCase().includes(searchText.toLowerCase())) {
      return true
    } else {
      return false
    }
  }

  return (
    <div className="w-full bg-tracer-dark-blue mt-5">
      <form
        onSubmit={(e) => {
          e.preventDefault()
          saveDtcs(e)
        }}
      >
        <div className="w-full text-white px-12 py-6">
          <div className="flex ">
            <div className="w-1/2 pr-2">
              <InputText
                name="name"
                value={payload.name}
                label="Name"
                onChange={(e) => {
                  setPayload({ ...payload, name: e })
                }}
                wrapperClass="p-0"
                type={`text`}
              />
            </div>
            <div className="w-1/2">
              <SelectInput
                value={ecusData.filter(
                  (option) => option.value === payload?.ecu
                )}
                onChange={(value) => {
                  setPayload({ ...payload, ecu: value.value })
                }}
                label="Select ECU"
                name="ecu"
                isRequired={true}
                options={ecusData}
                filterOption={onEcuInputSearch}
              />
            </div>
          </div>
          <div className="flex ">
            <div className="w-1/3 pr-2">
              <TextArea
                name="short_description"
                value={payload.short_description}
                label="Short Description"
                onChange={(e) => {
                  setPayload({ ...payload, short_description: e })
                }}
                wrapperClass="p-2"
                isRequired={false}
                maxLength={128}
              />
            </div>
            <div className="w-1/3 pr-2">
              <TextArea
                name="description"
                value={payload.description}
                label="Description"
                onChange={(e) => {
                  setPayload({ ...payload, description: e })
                }}
                wrapperClass="p-2"
                isRequired={false}
                maxLength={128}
              />
            </div>
            <div className="w-1/3">
              <TextArea
                name="description_2"
                value={payload.description_2}
                label="Description 2"
                onChange={(e) => {
                  setPayload({ ...payload, description_2: e })
                }}
                wrapperClass="p-2"
                isRequired={false}
              />
            </div>
          </div>
          <div className="flex content-center items-center">
            <div className="w-1/3">
              <div className="py-2">
                <span className="flex pt-4 items-center">
                  <CheckBox
                    name={'active'}
                    value={payload?.active}
                    checked={payload?.active}
                    onChange={(e) => {
                      setPayload({ ...payload, active: e.target.checked })
                    }}
                  />
                  <span className="pl-2 text-white">Active</span>
                </span>
              </div>
            </div>
            <div className="w-1/3">
              <div className="py-2 ">
                <span className="flex items-center">
                  <CheckBox
                    name={'destination_only'}
                    value={payload?.destination_only}
                    checked={payload?.destination_only}
                    onChange={(e) => {
                      setPayload({
                        ...payload,
                        destination_only: e.target.checked,
                      })
                    }}
                  />
                  <span className="pl-2 text-white">Destination Only</span>
                </span>
              </div>
            </div>
          </div>
          <div className="flex justify-end">
            <input
              type="button"
              className={`cursor-pointer btn danger my-4 px-5 mr-2`}
              style={{ width: 100 }}
              onClick={(e) => navigate(`/vehicles/${vehicle}/dtcs/listing`)}
              value="Cancel"
            />
            <Button
              type="submit"
              className={`cursor-pointer cursor-pointer btn my-4 px-5`}
              onClick={(e) => () => {}}
              value={'text'}
              text="Save DTC"
            />
          </div>
        </div>
      </form>
    </div>
  )
}

export default CreateDtcForm
